import React from 'react';
import PropTypes from 'prop-types';
import SpecialPagesListContainer from 'components/SpecialPages/containers/SpecialPagesListContainer';
import NotFound from 'components/Common/NotFound';

import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';

import SpecialPagesListItem from './SpecialPagesListItem';

const SpecialPagesList = props => {
  if (props.requestState.inProgress) {
    return <MediumPreLoader />;
  }
  if (props.itemsIds.length === 0) {
    return (
      <div className="container">
        <NotFound />
      </div>
    );
  }
  return (
    <div className="container">
      {props.itemsIds.map(itemId => (
        <SpecialPagesListItem
          key={`specialPagesListItem-${itemId}`}
          item={props.selectItemById(itemId)}
        />
      ))}
    </div>
  );
};

SpecialPagesList.propTypes = {
  // CONNECT STATES
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectItemById: PropTypes.func.isRequired
};

export default SpecialPagesListContainer(SpecialPagesList);



// WEBPACK FOOTER //
// ./src/components/SpecialPages/SpecialPagesList/SpecialPagesList.js